export default __webpack_public_path__ + "images/38a7d4b3972eeb254865c0c902489d55-television.jpg";